import { Link } from "react-router-dom";
import { whatsAppIcon } from "../../shared/assets/svg/whatsAppIcon";
import { useOnScroll } from "../../shared/hooks/useOnScroll";
import styles from './WhatsApp.module.scss';

const Whatsapp = () => {
    const { isShow } = useOnScroll();
    return ( 
        <div>
            {isShow &&
                <Link to ='tel:+79288408020'
                    className={styles.link}                   
                    type='button'
                >
                    {whatsAppIcon()}
                    <span className='visually-hidden'>Whatsapp</span>
                </Link>
            }
        </div>
     );
}
 
export default Whatsapp;